import { IApiConfiguration } from "./IApiConfiguration";
import { IApiJdeConfiguration } from "./IApiJdeConfiguration";
import { IEnvironment } from "./IEnvironment";

const env: IEnvironment = (window as any).APP_CONFIG;

export { env, IEnvironment, IApiConfiguration, IApiJdeConfiguration };
